var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12"},[_c('card',{staticClass:"responsive-card-table"},[_c('h2',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Gestione utenti")]),_c('users-table')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }